import { drawSquare } from "./Utils.js";
const sides = 4;
export class SquareDrawer {
    draw(data) {
        drawSquare(data);
    }
    getSidesCount() {
        return sides;
    }
}
